import { useContext } from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import { ActivitiesContext } from "../../context/activities/ActivitiesContext";
import GradientButton from "../input/GradientButton";

const EXAMPLE_ACTIVITIES = [
	{
		name: "Morning Exercise",
		emoji: "1f3cb-fe0f",
		color: "#619c43",
		description: "30 minutes of cardio or strength training",
	},
	{
		name: "Practice Guitar",
		emoji: "1f3b8",
		color: "#c26229",
		description: "Work on your guitar technique",
	},
	{
		name: "Meditation",
		emoji: "1f9d8",
		color: "#813773",
		description: "15 minutes of mindfulness practice",
	},
	{
		name: "Reading Time",
		emoji: "1f4da",
		color: "#276580",
		description: "Catch up on that book you've been meaning to read",
	},
];

const EmptyActivitiesState = () => {
	const { openCreateDialog } = useContext(ActivitiesContext);

	return (
		<Card className="activities-page__card activities-page__empty-card">
			<CardContent
				sx={{
					display: "flex",
					flexDirection: "column",
					flex: 1,
					minHeight: 0,
					height: "100%",
					py: 5,
					px: 3,
					boxSizing: "border-box",
					"&:last-child": { pb: 5 },
				}}
			>
				{/* Hero */}
				<Box sx={{ textAlign: "center", mb: 5, flexShrink: 0 }}>
					<Typography sx={{ fontSize: "3.5rem", mb: 2, lineHeight: 1 }}>
						🎯
					</Typography>
					<Typography variant="h2" sx={{ mb: 1.5, fontWeight: 600 }}>
						No activities yet
					</Typography>
					<Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
						Activities are things you do regularly but never really complete.
						Like hobbies.
					</Typography>
					<Box sx={{ display: "flex", justifyContent: "center" }}>
						<GradientButton text="Create Activity" onClick={openCreateDialog} />
					</Box>
				</Box>

				{/* Examples */}
				<Box
					className="scroller"
					sx={{
						flex: 1,
						minHeight: 0,
						overflowY: "auto",
						pb: "calc(80px + env(safe-area-inset-bottom))",
					}}
				>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ mb: 2, textAlign: "center", fontStyle: "italic" }}
					>
						Examples of activities you might create:
					</Typography>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
						{EXAMPLE_ACTIVITIES.map((example, index) => (
							<Box
								key={index}
								className="activities-page__ghost-activity"
								sx={{
									display: "flex",
									alignItems: "center",
									py: 1.5,
									px: 2,
									borderLeft: `3px solid ${example.color}`,
									position: "relative",
								}}
							>
								<Box
									sx={{
										width: 36,
										height: 36,
										borderRadius: "50%",
										bgcolor: example.color,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										mr: 2,
										flexShrink: 0,
									}}
								>
									<Emoji unified={example.emoji} size={18} />
								</Box>
								<Box sx={{ flex: 1 }}>
									<Typography
										variant="body2"
										sx={{ fontWeight: 500, fontSize: "0.9rem" }}
									>
										{example.name}
									</Typography>
									<Typography variant="caption" color="text.secondary">
										{example.description}
									</Typography>
								</Box>
							</Box>
						))}
					</Box>
				</Box>
			</CardContent>
		</Card>
	);
};

export default EmptyActivitiesState;
